module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "card-header"
  }, [_c('h4', [_vm._v("\n    " + _vm._s(_vm.titulo) + " \n    "), _c('small', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.abreModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.subtitulo))])])]), _vm._v(" "), (this.autenticados.length > 1) ? _c('div', {
    staticClass: "registros"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.funcionario),
      expression: "funcionario"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.funcionario = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.trocaUsuario(_vm.funcionario)
      }]
    }
  }, _vm._l((_vm.autenticados), function(autenticado) {
    return _c('option', {
      key: autenticado.id,
      domProps: {
        "value": autenticado
      }
    }, [_vm._v("\n          " + _vm._s('Registro ' + autenticado.registroFormatado) + "\n        ")])
  }), 0)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-user-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a973207","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/card-header/index.vue
// module id = pmgo
// module chunks = 5